import { Control, control } from 'leaflet'
import { CloseMap, closemap } from './Control.CloseMap'

Control.CloseMap = CloseMap
control.closemap = closemap

// @TODO: basta questo o vanno esportati? Credo di no, perché in questo modo li esponiamo tramite Control e control
